export enum MxConnectionStatus {
  CONNECTED = 'CONNECTED',
}
